// BF-5126: indexable pages also allow large image previews (Google Discover, News and image results).
// Kept free of app imports so scripts/tests can run it with plain Node.

export interface IRobotsSettings {
  advanced?: string;
  follow?: number;
  index?: number;
}

// Yoast stores index as 0 (default, index), 1 (noindex) or 2 (index) and follow as 0 (follow) or 1 (nofollow).
const INDEX_VALUES = ["index", "noindex", "index"];
const FOLLOW_VALUES = ["follow", "nofollow"];
const LARGE_IMAGE_PREVIEW = "max-image-preview:large";

export const buildRobotsContent = (robots: IRobotsSettings): string => {
  const directives = [
    INDEX_VALUES[robots.index || 0],
    FOLLOW_VALUES[robots.follow || 0],
    ...(robots.advanced || "").split(/[\s,]+/)
  ].filter(Boolean);

  const indexable = !directives.some((directive) => directive === "noindex" || directive === "none");
  const hasImagePreview = directives.some((directive) => directive.startsWith("max-image-preview:"));

  if (indexable && !hasImagePreview) {
    directives.push(LARGE_IMAGE_PREVIEW);
  }

  return directives.join(",");
};
